import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InfoCircle, Clock } from 'iconoir-react';
import { getStatusLoja, formatarReabertura } from '../utils/horarioUtils';

/**
 * Verifica se a loja está aberta (considerando horário E fechamento temporário)
 * @deprecated Use getStatusLoja() do horarioUtils para verificação completa
 */
export const checkLojaAberta = (loja) => {
  const status = getStatusLoja(loja);
  return status.aberta;
};

const LojaFechadaAlert = ({ loja }) => {
  const navigate = useNavigate();
  const [status, setStatus] = React.useState(() => getStatusLoja(loja));

  React.useEffect(() => {
    const checkStatus = () => {
      setStatus(getStatusLoja(loja));
    };

    checkStatus();
    // Verificar a cada 30 segundos para ser mais responsivo
    const interval = setInterval(checkStatus, 30000);
    return () => clearInterval(interval);
  }, [loja]);

  // Se está aberta, não mostrar alerta
  if (status.aberta) return null;

  // Determinar estilo baseado no tipo de fechamento
  const isFechamentoTemporario = status.status === 'FECHAMENTO_TEMPORARIO';
  const backgroundColor = isFechamentoTemporario ? '#fef3c7' : '#fef2f2';
  const borderColor = isFechamentoTemporario ? '#fcd34d' : '#fecaca';
  const iconColor = isFechamentoTemporario ? '#d97706' : '#dc2626';
  const titleColor = isFechamentoTemporario ? '#92400e' : '#991b1b';
  const textColor = isFechamentoTemporario ? '#78350f' : '#7f1d1d';

  return (
    <div style={{
      backgroundColor,
      border: `1px solid ${borderColor}`,
      borderRadius: '8px',
      padding: '12px 16px',
      margin: '16px 0',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px'
    }}>
      {isFechamentoTemporario ? (
        <Clock width={24} height={24} style={{ color: iconColor, flexShrink: 0, marginTop: '2px' }} />
      ) : (
        <InfoCircle width={24} height={24} style={{ color: iconColor, flexShrink: 0, marginTop: '2px' }} />
      )}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, color: titleColor, fontSize: '0.95rem', marginBottom: '4px' }}>
          {isFechamentoTemporario ? 'Temporariamente Fechada' : 'Loja Fechada'}
        </div>
        <div style={{ color: textColor, fontSize: '0.85rem' }}>
          {status.mensagem}
          {status.reaberturaProgramada && (
            <span style={{ display: 'block', marginTop: '4px', fontWeight: 500 }}>
              🕐 Reabertura prevista: {formatarReabertura(status.reaberturaProgramada)}
            </span>
          )}
          {status.proximaAbertura && !status.reaberturaProgramada && (
            <span style={{ display: 'block', marginTop: '4px' }}>
              Próxima abertura: {status.proximaAbertura}
            </span>
          )}
          {!isFechamentoTemporario && (
            <span 
              onClick={() => navigate('/loja')} 
              style={{ 
                display: 'block',
                marginTop: '6px',
                textDecoration: 'underline', 
                cursor: 'pointer', 
                fontWeight: 600 
              }}
            >
              Ver horário de funcionamento
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default LojaFechadaAlert;
